import { connect } from 'react-redux'
import React, { useEffect, useState, useRef } from 'react'
import renderImage from '../../../source/importImg'
import './Slider.css'

var initialRendered = true

const SliderRange = (props) => {
    console.log('imge:', props.rangImgName)
    const sliderStyle = {
        background: `${
            props.rangImgName === 'frequency_slider'
                ? 'linear-gradient(90deg, #FFE9C2 -8.7%, #FFBC45 100%)'
                : props.rangImgName === 'red_slider'
                  ? 'linear-gradient(90deg, #EF9A9A 0%, #D92100 100%)'
                  : props.rangImgName === 'blue_slider'
                    ? 'linear-gradient(90deg, #B2EBF2 0%, #018CF7 99.35%)'
                    : props.rangImgName === 'green_slider'
                      ? 'linear-gradient(90deg, #A5D6A7 0%, #3BB273 100%)'
                      : 'linear-gradient(90deg, #F2F2F2 -8.69%, #707070 100%)'
        }`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',
    }

    // Fallback to props.value or props.val if provided by the new PlayScreen
    const [isChangeRangeValue, setChangeRangeValue] = useState(
        props.value ?? props.val ?? 0
    )
    const [isinitialStop, setInitialStop] = useState(false)

    // NEW: Safely target this specific slider's thumb without breaking legacy CSS IDs
    const selectorRef = useRef(null)

    // NEW: Sync local state when parent overrides the value (e.g. PlayScreen step navigation)
    useEffect(() => {
        const incomingValue = props.value ?? props.val
        if (
            incomingValue !== undefined &&
            incomingValue !== isChangeRangeValue
        ) {
            setChangeRangeValue(incomingValue)
            if (selectorRef.current) {
                selectorRef.current.style.left = incomingValue + '%'
            }
        }
    }, [props.value, props.val])

    const rangeSlider = (e) => {
        if (props.disable) return

        // Prefer ref for safety with multiple sliders, fallback to legacy getElementById if ref fails
        if (selectorRef.current) {
            selectorRef.current.style.left = e.target.value + '%'
        } else {
            let selectorContainer = document.getElementById('selectorContainer')
            if (selectorContainer)
                selectorContainer.style.left = e.target.value + '%'
        }

        setChangeRangeValue(e.target.value)
        setInitialStop(true)

        if (props.onChangehandler) {
            props.onChangehandler(e.target.value, props.title)
        }

        // --- LEGACY CODE PRESERVED BELOW ---
        if (props.componentName === 'L_green') props.setL_Green(e.target.value)
        if (props.componentName === 'L_blue') props.setL_Blue(e.target.value)
        if (props.componentName === 'L_red') props.setL_Red(e.target.value)

        if (props.componentName === 'R_green') props.setR_Green(e.target.value)
        if (props.componentName === 'R_blue') props.setR_Blue(e.target.value)
        if (props.componentName === 'R_red') props.setR_Red(e.target.value)

        if (props.componentName === 'freq') props.setFreq(e.target.value)
    }

    useEffect(() => {
        if (props.disable || !props.webSerial?.isConnected) {
            if (props.componentName === 'L_green') props.setL_Green(0)
            if (props.componentName === 'L_blue') props.setL_Blue(0)
            if (props.componentName === 'L_red') props.setL_Red(0)

            if (props.componentName === 'R_green') props.setR_Green(0)
            if (props.componentName === 'R_blue') props.setR_Blue(0)
            if (props.componentName === 'R_red') props.setR_Red(0)

            if (props.componentName === 'freq') props.setFreq(0)

            setChangeRangeValue(0)
            if (selectorRef.current) selectorRef.current.style.left = '0%'
        }
    }, [props.disable, props.webSerial?.isConnected])

    return (
        <div className="SliderRangeContainer">
            <p
                style={{
                    color: '#4527A0',
                    fontSize: '1.5vw',
                    marginLeft: '-15px',
                    justifySelf: 'end',
                }}
            >
                {' '}
                {/* {props.title} */}
            </p>

            <div className="SliderRangeMain">
                <input
                    type="range"
                    min={0}
                    max={100}
                    value={isChangeRangeValue}
                    // id="sliderRange"
                    style={sliderStyle}
                    onChange={rangeSlider}
                    onMouseUp={() => {
                        setTimeout(() => {
                            if (props.disable) return
                            if (props.leftEyeData) props.leftEyeData()
                        }, 200)
                    }}
                />
                {/* ID remains for legacy CSS, ref added for React manipulation, inline style added for prop syncing */}
                {/* <div
                    id="selectorContainer"
                    ref={selectorRef}
                    style={{ left: `${isChangeRangeValue}%` }}
                >
                    <div className="selectorButtonImg"></div>
                </div> */}
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return state
}
export default connect(mapStateToProps)(SliderRange)
